import React from 'react';

import { ConfluenceIcon, JiraIcon, LoomIcon } from '@atlaskit/logo';
import { IconTile } from '@atlaskit/icon';
import { Flex } from '@atlaskit/primitives/compiled';
import LinkIcon from '@atlaskit/icon/core/link';

import type { PopularQuestionsQuery$data } from './__generated__/PopularQuestionsQuery.graphql.ts';

type Source = NonNullable<
	NonNullable<
		NonNullable<
			NonNullable<
				NonNullable<PopularQuestionsQuery$data['confluence_smartSpaceOverview']>['faq']
			>['entries']
		>[number]['sources']
	>[number]
>;

const iconOverrides = {
	Confluence: ConfluenceIcon,
	Jira: JiraIcon,
	Loom: LoomIcon,
};

type AppIconProps = {
	url?: string | null;
	completeKey?: string | null;
};

export const getSourceIcon = ({ url, completeKey }: AppIconProps) => {
	if (completeKey) {
		const IconOverride = iconOverrides[completeKey];
		if (IconOverride) {
			return <IconOverride size="xsmall" appearance="brand" shouldUseNewLogoDesign />;
		}
	}

	if (!url) {
		return <IconTile icon={LinkIcon} appearance="blue" size="xsmall" label="" />;
	}

	return (
		<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" data-testid="app-icon">
			<defs>
				<filter id="changeFillColor">
					<feColorMatrix
						type="matrix"
						values="0.02, 0, 0, 0, 0, 0, 0.04, 0, 0, 0, 0, 0, 0.07, 0, 0, 0, 0, 0, 1, 0"
					/>
				</filter>
			</defs>
			{/* eslint-disable-next-line no-restricted-syntax */}
			<image
				xmlnsXlink="http://www.w3.org/1999/xlink"
				xlinkHref={url}
				width="16"
				height="16"
				x="0"
				y="0"
				filter={isSvg(url) ? 'url(#changeFillColor)' : ''}
			/>
		</svg>
	);
};

export const getSourceIconStack = (sources: readonly Source[]) => {
	const uniqueIconUrls = Array.from(
		new Set(sources.map((source) => source?.content?.embeddedProduct)),
	);
	return (
		<Flex>
			{uniqueIconUrls.map((product) => (
				<>{getSourceIcon({ url: undefined, completeKey: product })}</>
			))}
		</Flex>
	);
};

const isSvg = (url: string) => {
	const fileType = url.split(/\#|\?/)[0].split('.').pop();
	return !!fileType && fileType.trim() === 'svg';
};
